import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=5b56118a&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56118a",
  null
  
)

export default component.exports